<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(
  defineProps<{
    routeName: string
    title: string
    class: string
    color: string
    style: {[key: string]: string} | undefined
    disabled: boolean
    modelValue: boolean
    isMovable: boolean
  }>(),
  {
    class: '',
    disabled: false,
    color: '',
    style: undefined,
    isMovable: true,
    modelValue: true
  }
)

const router = useRouter()

const isClicked = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

function movePage() {
  isClicked.value = true;
  if (!props.isMovable) {
    return
  }
  router.push({ name: props.routeName });
}
</script>
<template>
  <v-btn
    :class="props.class"
    :color="props.color"
    :style="props.style"
    :disabled="props.disabled"
    @click="movePage"
  >
    {{ props.title }}
  </v-btn>
</template>
